export default "/pt-weeths.f31e4491543ee367bcc39ad0eb9bffdd.svg";